import { Directive, HostListener } from '@angular/core';
// import screenfull = require('screenfull');
import * as screenfull from 'screenfull';

@Directive({
    selector: '[appToggleFullscreen]'
})
export class ToggleFullscreenDirective {
	@HostListener('click') onClick() {
		if (screenfull.enabled) {
			screenfull.toggle();
		}
	}
}
// export class ToggleFullscreenDirective {
// 	@HostListener('click') onClick() {
// 		if (screenfull.isEnabled) {
// 			screenfull.toggle();
// 		}
// 	}
// }



// WEBPACK FOOTER //
// /Users/cricketmon/Sites/clubsandwichadmin/src/app/shared/fullscreen/toggle-fullscreen.directive.ts